import { z } from "zod";

import type { ViewLoadError } from "./types";

const viewLoadErrorBaseSchema = z.object({
  viewId: z.string(),
  version: z.string(),
  cdnUrl: z.string(),
});

export const viewLoadErrorSchema = z.discriminatedUnion("code", [
  viewLoadErrorBaseSchema.extend({
    code: z.literal("NETWORK_ERROR"),
    cause: z.instanceof(Error),
  }),
  viewLoadErrorBaseSchema.extend({
    code: z.literal("INVALID_VIEW"),
    reason: z.string(),
  }),
  viewLoadErrorBaseSchema.extend({
    code: z.literal("IMPORT_ERROR"),
    cause: z.instanceof(Error),
  }),
]);

export function isViewLoadError(value: unknown): value is ViewLoadError {
  return viewLoadErrorSchema.safeParse(value).success;
}
